import React, { forwardRef } from 'react'
import { StyleSheet, TextInput, View } from 'react-native'
import DatePickerWeb from 'react-datepicker'
import { getNextMinimumValidDateTime } from '@ppwr/poker'
import { DS } from '@/design-system'
import { translate } from '../../../i18n'

import 'react-datepicker/dist/react-datepicker.css'

interface ScheduleDateTimeFieldsProps {
  value: Date
  onChange: (date: Date) => void
}

// biome-ignore lint/suspicious/noExplicitAny: react-datepicker input props
const CustomInput = forwardRef((props: any, ref) => (
  <TextInput {...props} ref={ref} editable={false} style={styles.input} />
))

export function ScheduleDateTimeFields({ value, onChange }: ScheduleDateTimeFieldsProps) {
  const minimumDate = getNextMinimumValidDateTime()

  return (
    <View style={styles.row}>
      <View style={styles.field}>
        <DS.Text variant="Body Medium/Regular" style={styles.label}>
          {translate('createGameV2.group.date')}
        </DS.Text>
        <DatePickerWeb
          selected={value}
          onChange={(date) => date && onChange(date)}
          minDate={minimumDate}
          dateFormat="EEE MMM d"
          customInput={<CustomInput />}
        />
      </View>
      <View style={styles.field}>
        <DS.Text variant="Body Medium/Regular" style={styles.label}>
          {translate('createGameV2.group.time')}
        </DS.Text>
        <DatePickerWeb
          selected={value}
          onChange={(date) => date && onChange(date)}
          minDate={minimumDate}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={15}
          timeCaption="Time"
          dateFormat="h:mm aa"
          customInput={<CustomInput />}
        />
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    gap: 20
  },
  field: {
    flex: 1,
    gap: 6
  },
  label: {
    color: DS.palette['Global/Black']
  },
  input: {
    height: 48,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: DS.palette['Brand/Light Grey'],
    paddingHorizontal: 12,
    backgroundColor: DS.palette['Global/White'],
    color: DS.palette['Global/Black'],
    fontSize: 16,
    width: '100%'
  }
})
